import { Phone, Clock, Mail } from "lucide-react";

const TopBar = () => {
  return (
    <header className="hidden sm:block bg-accent text-accent-foreground">
      <div className="container-max flex flex-col sm:flex-row items-center justify-between px-4 py-2 text-xs sm:text-sm gap-1 sm:gap-0">
        <div className="flex items-center gap-4">
          <a href="mailto:fgoodchoice@gmail.com" className="flex items-center gap-2 hover:text-primary transition-colors">
            <Mail className="h-3.5 w-3.5 text-primary" />
            <span>fgoodchoice@gmail.com</span>
          </a>
          <div className="hidden md:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-primary" />
            <span>Mon–Fri 7 AM–7 PM · Sat–Sun 9 AM–5 PM</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <a href="tel:+15405604862" className="flex items-center gap-2 hover:text-primary transition-colors font-semibold">
            <Phone className="h-3.5 w-3.5 text-primary" />
            <span>(540) 560-4862</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
